// programatically open chat

const livechatListener = () => {
    const livechatToggleElements = [...document.querySelectorAll('.js-open-chat')].filter(
        (el) => !el.dataset.livechatToggleInitialized
    );

    livechatToggleElements.forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            if (
                typeof window.LC_API !== 'undefined' &&
                typeof window.LC_API.open_chat_window !== 'undefined'
            ) {
                window.LC_API.open_chat_window();
            }

            return false;
        });

        item.dataset.livechatToggleInitialized = true;
    });
};

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        livechatListener();
    });
});
